export default "__VITE_ASSET__DfrO8ZRs__"